import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { captureAttribution } from "@/lib/attribution";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import ServiceLeafPage from "@/pages/ServiceLeafPage";
import RegionPage from "@/pages/RegionPage";
import IndustryPage from "@/pages/IndustryPage";
import CoverageIndex from "@/pages/CoverageIndex";
import CaseStudiesIndex from "@/pages/CaseStudiesIndex";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import TermsAndConditions from "@/pages/TermsAndConditions";
import TeamPage from "@/pages/about/TeamPage";
import QualityAndCompliancePage from "@/pages/about/QualityAndCompliancePage";
import AccreditationsPage from "@/pages/about/AccreditationsPage";
import CareersPage from "@/pages/about/CareersPage";
import InsightsIndex from "@/pages/InsightsIndex";
import InsightsArticle from "@/pages/InsightsArticle";
import StructuredData from "@/components/StructuredData";
import Analytics from "@/components/Analytics";
import Crisp from "@/components/Crisp";
import CookieConsent from "@/components/CookieConsent";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    captureAttribution();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Analytics />
        <Crisp />
        <CookieConsent />
        <StructuredData />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceLeafPage />} />
            <Route path="/coverage" element={<CoverageIndex />} />
            <Route path="/coverage/:slug" element={<RegionPage />} />
            <Route path="/industries/:slug" element={<IndustryPage />} />
            <Route path="/case-studies" element={<CaseStudiesIndex />} />
            <Route path="/insights" element={<InsightsIndex />} />
            <Route path="/insights/:slug" element={<InsightsArticle />} />
            <Route path="/about" element={<About />} />
            <Route path="/about/team" element={<TeamPage />} />
            <Route path="/about/quality-and-compliance" element={<QualityAndCompliancePage />} />
            <Route path="/about/accreditations" element={<AccreditationsPage />} />
            <Route path="/about/careers" element={<CareersPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
